<common-top-tool-bar [title]="'编辑AI口语话题'"
                     [back]="'/admin/v3/resource/'+bisType+'/edit/'+book_id"
                     [query]="{tabIndex: 1}"
                     [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button [nzType]="'primary'" class="mr-4"
            [nzSize]="'large'" nzGhost
            [queryParams]="{ tabIndex: 1 }"
            [routerLink]="'/admin/v3/resource/'+bisType+'/edit/'+book_id+'/index'">
      取消
    </button>
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            (click)="saveTopics()">
      保存
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-main">
  <nz-spin [nzSpinning]="isLoading">
    <div class="page-main-header">
      <div class="page-main-header-tools">
        <button nz-button nzType="primary" nzGhost (click)="addTopic()">
          <i nz-icon nzType="plus" nzTheme="outline" class="fix-icon"></i>
          新增话题
        </button>
      </div>
      <div class="page-main-header-actions">
        <button nz-button nzType="default" nzDanger class="mr-4" (click)="removeTopic()">删除此话题</button>
      </div>
    </div>

    <div class="page-main-table">
      <div class="table-header"></div>
      <nz-tabs nzType="line"
                 [nzTabPosition]="'left'"
                 [nzSelectedIndex]="currentTopicIndex"
                 (nzSelectedIndexChange)="topicIndexChange($event)">

        <nz-tab *ngFor="let topic of topics; let i = index"
                [nzClosable]="false"
                [nzTitle]="titleTemplate">
          <ng-template #titleTemplate>
            <div style="font-size: 14px">
              <div class="px-2"></div>
              {{ '话题' + (i + 1) }}
            </div>
          </ng-template>

          <ng-template nz-tab>
            <div class="p-8" style="padding-left: 8px;">
              <div nz-row>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>上传话题图片</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <div class="flex items-end flex-wrap">
                        <app-upload-image-with-preview-v2
                          [picPreview]="true"
                          style="width: 180px;display: inline-block;"
                          [picUrl]="topic.image"
                          (imageUploaded)="onTopicImageUploaded(i, $event)"
                          previewClass="bg-cover bg-center"
                          [displayRatioWidth]="0"
                          [displayRatioHeight]="0">
                        </app-upload-image-with-preview-v2>
                        <div class="font-light text-xs px-4">注：图片格式为 Jpg 或 Png 文件，图片文件大小限制为 2MB</div>
                      </div>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired class="image-content-label">
                      <span class="image-content-label-row">
                        <span>图片内容</span>
                        <button nz-button
                                nzType="primary"
                                nzGhost
                                nzSize="small"
                                [nzLoading]="isAnalyzingTopicImage(i)"
                                [disabled]="!canAnalyzeTopicImage(i) || isAnalyzingTopicImage(i)"
                                (click)="$event.stopPropagation(); analyzeTopicImage(i)">
                          识别图片
                        </button>
                      </span>
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <textarea nz-input
                                [(ngModel)]="topic.imageContent"
                                placeholder="上传图片后可点击「识别图片」自动填充，也可手动编辑"
                                [nzAutosize]="{ minRows: 4, maxRows: 10 }"></textarea>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>开场白</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <textarea nz-input
                                [(ngModel)]="topic.openingLine"
                                placeholder="请输入开场白"
                                [nzAutosize]="{ minRows: 3, maxRows: 6 }"></textarea>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>话题关键词&句式&话题示例</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <textarea nz-input
                                [(ngModel)]="topic.description"
                                placeholder="请输入话题关键词、句式与话题示例"
                                [nzAutosize]="{ minRows: 4, maxRows: 8 }"></textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </ng-template>
        </nz-tab>
      </nz-tabs>
    </div>
  </nz-spin>
</div>
